// Keep provider results as unverified prospects, never active hosts.
export function buildProspectPayload(result, search) {
  return {
    org_name: result.name,
    contact_phone: result.phone || null,
    contact_email: result.email || null,
    website: result.website || null,
    address: result.address || null,
    city: search.city,
    province: search.province,
    programs_accepted: [search.program],
    notes: `Found via Host Finder (${search.source || 'OpenStreetMap'}) — ${result.category}. Potential prospect; placement availability has not been confirmed.`,
  };
}
